// src/components/SevenAmSubscribe.jsx
// Bloque de suscripción newsletter 7AM Library
// Reutilizable en todas las páginas de episodio

import React, { useState } from 'react';
import axios from 'axios';
import { Mail, ArrowRight, Check } from 'lucide-react';

export default function SevenAmSubscribe() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(() =>
    localStorage.getItem('7am_subscribed') === 'true' ? 'success' : 'idle'
  );
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmed)) {
      setErrorMsg('Ingresa un correo válido.');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      await axios.post('/api/leads/7am-library', { email: trimmed });
      localStorage.setItem('7am_subscribed', 'true');
      setStatus('success');
    } catch (err) {
      const msg = err?.response?.data?.error;
      setErrorMsg(msg || 'Ocurrió un error. Inténtalo de nuevo.');
      setStatus('error');
    }
  };

  return (
    <section className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 pb-5 sm:pb-12">
      <div
        className="rounded-xl sm:rounded-2xl overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #0c1a2e 0%, #162944 60%, #0e2240 100%)' }}
      >
        <div className="h-0.5 w-full bg-gradient-to-r from-amber-400 to-yellow-500" />

        <div className="px-5 sm:px-10 py-7 sm:py-10">

          {status === 'success' ? (
            /* ── ESTADO CONFIRMADO ── */
            <div className="flex items-center gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-400 flex items-center justify-center">
                <Check className="w-5 h-5 text-slate-900" strokeWidth={2.5} />
              </div>
              <div>
                <p className="text-white font-semibold text-sm sm:text-base leading-snug">
                  Listo. Te avisamos cuando llegue el próximo episodio.
                </p>
                <p className="text-white/40 text-xs mt-0.5">
                  Un correo por episodio. Sin spam.
                </p>
              </div>
            </div>
          ) : (
            /* ── ESTADO FORMULARIO ── */
            <div className="flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-8">

              {/* Texto */}
              <div className="flex-shrink-0">
                <div className="flex items-center gap-2 mb-1">
                  <Mail className="w-4 h-4 text-amber-400" strokeWidth={1.5} />
                  <p className="text-xs font-bold text-amber-400 tracking-[0.2em] uppercase">
                    Newsletter
                  </p>
                </div>
                <p className="text-white font-semibold text-base sm:text-lg leading-snug">
                  No te pierdas el siguiente análisis.
                </p>
                <p className="text-white/40 text-xs mt-1">
                  Un correo por episodio. Sin spam.
                </p>
              </div>

              {/* Formulario */}
              <form
                onSubmit={handleSubmit}
                className="flex flex-col sm:flex-row gap-2 w-full sm:max-w-sm"
                noValidate
              >
                <input
                  type="email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setErrorMsg(''); setStatus('idle'); }}
                  placeholder="tu@correo.com"
                  className="flex-1 px-4 py-2.5 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/30 text-sm focus:outline-none focus:border-amber-400 focus:bg-white/15 transition-colors"
                  disabled={status === 'loading'}
                  aria-label="Correo electrónico"
                  autoComplete="email"
                />
                <button
                  type="submit"
                  disabled={status === 'loading' || !email.trim()}
                  className="flex-shrink-0 inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-amber-400 hover:bg-amber-300 disabled:opacity-50 disabled:cursor-not-allowed text-slate-900 text-sm font-bold rounded-lg transition-colors"
                >
                  {status === 'loading' ? (
                    <span className="w-4 h-4 border-2 border-slate-900/30 border-t-slate-900 rounded-full animate-spin" />
                  ) : (
                    <>
                      Suscribirme
                      <ArrowRight className="w-3.5 h-3.5" />
                    </>
                  )}
                </button>
              </form>

            </div>
          )}

          {/* Error inline */}
          {status === 'error' && errorMsg && (
            <p className="text-red-400 text-xs mt-3">{errorMsg}</p>
          )}
          {status === 'idle' && errorMsg && (
            <p className="text-red-400 text-xs mt-3">{errorMsg}</p>
          )}

        </div>
      </div>
    </section>
  );
}
